/*
 *
 * Chatbot
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 16-Apr-2025
*/

import Chatbot from './ChatbotContainer'

export default Chatbot
